// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"ToolsList_dropdown__2vdE1","dropdown_inner":"ToolsList_dropdown_inner__mAm1Q","tools_title":"ToolsList_tools_title___fbFF"};